import { SkeletonLoaderArea, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleSm};
  color: var(--text-soft);
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

export const TargetsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const styledLoaderAreas: SkeletonLoaderArea[] = [
  {
    styles: {
      width: '100%',
      height: '100px',
      borderRadius: '8px',
    },
  },
];
